<h1>{{ localization.title }}</h1>
<div *ngIf="isSuccess" class="success">
  {{ localization.success }}
</div>
<div *ngIf="isError" class="error">
  {{ localization.error }}
</div>
<mtg-spinner *ngIf="isLoading"></mtg-spinner>
